// Client REAL de Conciliación. ⚠️ El backend es de OTRO equipo y el contrato está por acordarse —
// ver settlementContract.ts.
import { apiFetch } from '../../../client';
import type {
    ReconciliationFolio,
    ReconciliationResponse,
    SettlementApi,
} from './settlementContract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

export const settlementClient: SettlementApi = {
    getReconciliation: (range) =>
        apiFetch<ReconciliationResponse>(
            `/backoffice/settlement/reconciliation?from=${encodeURIComponent(range.from)}&to=${encodeURIComponent(range.to)}`,
            { baseUrl: BASE_URL },
        ),
    getFolios: (date: string, storeId: string) =>
        apiFetch<{ items: ReconciliationFolio[] }>(
            `/backoffice/settlement/reconciliation/folios?date=${encodeURIComponent(date)}&storeId=${encodeURIComponent(storeId)}`,
            { baseUrl: BASE_URL },
        ),
};
